import React from 'react'
import ListQuestion from '../../../components/organisms/admin/question/ListQuestion'

type Props = {}

const ListQuestionPage = (props: Props) => {
  return (
    <ListQuestion />
  )
}

export default ListQuestionPage
